import { Schema } from "effect";

export const MessageRedoChatConfirmationState = Schema.Literal(
  "pending",
  "confirmed",
  "rejected",
);
export type MessageRedoChatConfirmationState =
  typeof MessageRedoChatConfirmationState.Type;
